import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Cape Verde (1-16)
import capeverde1 from '../images/capeverde1.jpeg';
import capeverde2 from '../images/capeverde2.jpeg';
import capeverde3 from '../images/capeverde3.jpeg';
import capeverde4 from '../images/capeverde4.jpeg';
import capeverde5 from '../images/capeverde5.jpeg';
import capeverde6 from '../images/capeverde6.jpeg';
import capeverde7 from '../images/capeverde7.jpeg';
import capeverde8 from '../images/capeverde8.jpeg';
import capeverde9 from '../images/capeverde9.jpeg';
import capeverde10 from '../images/capeverde10.jpeg';
import capeverde11 from '../images/capeverde11.jpeg';
import capeverde12 from '../images/capeverde12.jpeg';
import capeverde13 from '../images/capeverde13.jpeg';
import capeverde14 from '../images/capeverde14.jpeg';
import capeverde15 from '../images/capeverde15.jpeg';
import capeverde16 from '../images/capeverde16.jpeg';

function CapeVerde() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    capeverde1, capeverde2, capeverde3, capeverde4, capeverde5, capeverde6,
    capeverde7, capeverde8, capeverde9, capeverde10, capeverde11, capeverde12,
    capeverde13, capeverde14, capeverde15, capeverde16
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇨🇻 Cape Verde 2016 🇨🇻</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Cape Verde ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default CapeVerde;